import React from "react";

function EmptyTodo() {
  return <p>¡Crea tu primer TODO!</p>;
}

export { EmptyTodo };
